import styled from '@emotion/styled'
import { css } from '@emotion/react'

import media from '../../../../styles/media'
import { colors } from '../../../../styles/theme'

const S = {}

S.NavButton = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 1.125rem;
  transition: background-color 0.1s cubic-bezier(0, 0, 0.25, 1);
  user-select: none;

  path {
    fill: ${({ lightMode }) => (lightMode ? colors.shark : colors.silver)};
  }

  @media (hover: hover) {
    &:hover {
      background: ${({ lightMode }) =>
        lightMode ? colors.alabaster : colors.woodsmoke};

      path {
        fill: ${({ lightMode }) => (lightMode ? colors.black : colors.white)};
      }

      .menu-title {
        color: ${({ lightMode }) => (lightMode ? colors.black : colors.white)};
      }
    }
  }

  .menu-tab {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .menu-title {
    color: ${({ lightMode }) => (lightMode ? colors.shark : colors.silver)};
    text-transform: uppercase;
    font-weight: 900;
    font-size: 0.875rem;
    display: none;
    line-height: 1.29;
    margin-left: 0.75rem;
    margin-right: 0.75rem;

    ${media.sm`
      display: block;
    `};
  }

  ${({ menuIsOpen, lightMode }) =>
    menuIsOpen &&
    css`
      background-color: ${lightMode ? colors.white : colors.woodsmoke};

      path {
        fill: ${lightMode ? colors.black : colors.white};
      }

      .menu-title {
        color: ${lightMode ? colors.black : colors.white};
      }
    `};
`

export default S
